import { HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Ordem } from 'src/app/core/model/ordem';
import { environment } from 'src/environments/environment';
import { ApiService } from '../util/api.service';
import { CustomHttpUrlEncodingCodec } from '../util/codecs/encoder';
import { HeadersRequest } from '../util/model/header-request.inteface';
import { TipoOrdem } from '../../model/enum/tipo-ordem.enum';
import { PageableModel } from 'src/app/shared/components/page-resource-list/models/pageable.model';
import { PageModel } from 'src/app/shared/components/page-resource-list/models/page.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SolicitacaoService {

  private basePath = environment.basePathApi + '/serasajud-solicitacao/v1';

  constructor(
    protected apiService: ApiService
  ) { }

  public saveSolicitacao(solicitacao: Ordem, auth: string) {
    return this.apiService.post(`${this.basePath}/ordens`, solicitacao, this.getHeaders(auth));
  }

  public getArquivoUrl(idDtDrive: string, auth: string) {
    return this.apiService.get(`${this.basePath}/ordens/${idDtDrive}/arquivo/urlDtDrive`, null, this.getHeaders(auth));
  }

  public getSiglaByNomePraca(uf: string, nome: string, auth: string) {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    queryParams = queryParams.set('nome', nome);
    return this.apiService.get<any>(`${this.basePath}/ordens/praca/${uf}`, queryParams, this.getHeaders(auth));
  }

  public consultarOrdensByOrgao(auth: string, pageable: PageableModel, nroProcesso?: string): Observable<HttpResponse<PageModel<Ordem>>> {
    let queryParams = this.getPageableParams(pageable);
    if (nroProcesso)
      queryParams = queryParams.set('numeroProcesso', nroProcesso);

    return this.apiService.get<any>(`${this.basePath}/ordens/orgao`, queryParams, this.getHeaders(auth));
  }

  public detalharOrdem(ordem: any, auth?: string) {
    return this.apiService.get<any>(`${this.basePath}/ordens/${ordem.id}`, null, this.getHeaders(auth));
  }

  public findByNroProcesso(numeroProcesso: string, tipoOrdemList: TipoOrdem[], auth: string) {
    let queryParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    tipoOrdemList.forEach(tipo => {
      queryParams = queryParams.append('tipoOrdem', tipo);
    });

    return this.apiService.get<any>(`${this.basePath}/ordens/${numeroProcesso}/ultima`,
      queryParams,
      this.getHeaders(auth)
    );
  }

  public validarNumeroProcesso(numeroProcesso: string, auth?: string) {
    return this.apiService.get<any>(`${this.basePath}/ordens/${numeroProcesso}/validar`, null, this.getHeaders(auth));
  }

  private getHeaders(auth: string): Array<HeadersRequest> {
    const headers: Array<HeadersRequest> = new Array<HeadersRequest>();
    headers.push({param: 'Authorization', value: 'Bearer ' + auth});
    return headers;
  }

  private getPageableParams(pageable: PageableModel): HttpParams {
    let params = new HttpParams().set('page', pageable.page.toString()).set('size', pageable.size.toString());
    if (pageable.sort && pageable.sort.field) {
      params = params.set('sort', pageable.sort.field + ',' + pageable.sort.order);
    }
    return params;
  }

}
